// extracted by mini-css-extract-plugin
module.exports = {"container":"post-list-module--container--2AqiX","post":"post-list-module--post--1gkyY","cover":"post-list-module--cover--31q1n","content":"post-list-module--content--ixjr-"};